import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
//import { FateModule } from 'fate-editor';
import { FileSizePipe } from '../_core/_pipe/file-size.pipe';
import { CommonModule } from '@angular/common';
import { ProjFilterPipe } from '../_core/_pipe/proj-filter.pipe';
import { UnitsFilterPipe } from '../_core/_pipe/units-filter.pipe';
import { CompProjFilterPipe } from '../_core/_pipe/comp-proj-filter.pipe';
import { SortGridPipe } from '../_core/_pipe/filtering-by-date.pipe';
import { SortBigestNumber } from '../_core/_pipe/bigest-number.pipe';
import { SortBigestNumberArray } from '../_core/_pipe/bigest-number-array.pipe';
import { RankingNum } from '../_core/_pipe/rankingNum.pipe';
import { RoundUpPipe } from '../_core/_pipe/round2numbersAfterDot.pipe';
import { SortBigestFloorNumber } from '../_core/_pipe/bigest-floor.pipe';
import { SafePipe } from '../_core/_pipe/safe.pipe';
import { OrederByDatePipe } from '../_core/_pipe/oreder-by-date.pipe';
import { BuildingZonePipe } from '../_core/_pipe/building-zone.pipe';
import { filterPipe } from '../_core/_pipe/nfilter.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    FileSizePipe,
    SafePipe,
    OrederByDatePipe,
    BuildingZonePipe,
    ProjFilterPipe,
    UnitsFilterPipe,
    CompProjFilterPipe,
    SortGridPipe,
    SortBigestNumber,
    SortBigestNumberArray,
    RankingNum,
    RoundUpPipe,
    SortBigestFloorNumber,
    filterPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatPaginatorModule,
    //FateModule
  ],
  exports: [
    FileSizePipe,
    SafePipe,
    OrederByDatePipe,
    BuildingZonePipe,
    ProjFilterPipe,
    CompProjFilterPipe,
    UnitsFilterPipe,
    SortGridPipe,
    SortBigestNumber,
    SortBigestNumberArray,
    RankingNum,
    RoundUpPipe,
    SortBigestFloorNumber,
    FormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatPaginatorModule,
    //FateModule,
    CommonModule,
    filterPipe
  ]
})
export class SharedModule { }
